import { API_RESULT } from './api';

const UPDATE = 'modules/manageNumCartItems/UPDATE';

const reducer = (state = '', action) => {
  switch (action.type) {
    case UPDATE:
      let numCartItems = 0;
      if (action.updatedItems) {
        for (const item of Object.values(action.updatedItems)) {
          numCartItems += +item.quantity;
        }
      }
      return numCartItems;
    case API_RESULT:
      return parseInt(action.payload.numCartItems, 0);
    default:
      return state;
  }
};

const updateNumCartItems = updatedItems => {
  return {
    type: UPDATE,
    updatedItems
  };
};

export { reducer as default, updateNumCartItems };
